<div [ngClass]="metalLevelClass">
   {{metalLevel}} 
</div>
